<template>
  <div>
    <el-form inline class="form">
      <el-form-item label="名称：">
        <el-input v-model="form.name" placeholder="请输入" clearable></el-input>
      </el-form-item>
      <el-form-item label="更新时间：">
        <el-date-picker
          v-model="form.time"
          :unlink-panels="true"
          type="daterange"
          :clearable="true"
          :editable="false"
          range-separator="-"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getPublishList">筛选</el-button>
      </el-form-item>
    </el-form>
    <div style="text-align: right">
      <el-button type="primary" @click="dialogNewSheet = true">新建名单</el-button>
      <el-button type="primary" @click="dialogImport = true">导入名单</el-button>
      <PublishImportHistory></PublishImportHistory>
    </div>
    <el-dialog :visible.sync="dialogNewSheet" title="新建名单">
      <el-form label-width="70px">
        <el-form-item label="名称：" required>
          <el-input
            v-model="newSheet.name"
            show-word-limit
            maxlength="16"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
        <el-form-item label="类型：" required>
          <el-select v-model="newSheet.type" placeholder="请选择" style="width: 100%">
            <el-option
              v-for="item in typeOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="备注：">
          <el-input
            v-model="newSheet.remarks"
            show-word-limit
            maxlength="32"
            clearable
            placeholder="请输入"
          ></el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: right">
        <el-button @click="dialogNewSheet = false">取消</el-button>
        <el-button type="primary" @click="addSheet">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :visible.sync="dialogImport"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      width="600px"
      title="导入名单"
    >
      <el-steps :active="importStatus" align-center>
        <el-step title="选择导入名单"></el-step>
        <el-step title="选择文件"></el-step>
        <el-step title="上传文件"></el-step>
        <el-step title="导入结果"></el-step>
      </el-steps>
      <div class="import-container">
        <div v-show="importStatus === 0">
          <div style="padding-top: 50px; text-align: center">
            <el-select v-model="selectSheet" style="width: 300px">
              <el-option
                v-for="item in publishList"
                :key="item.RosterId"
                :label="item.RosterName"
                :value="item.RosterId"
              ></el-option>
            </el-select>
          </div>
        </div>
        <div v-show="importStatus === 1">
          <div>
            <el-upload
              ref="upload"
              class="upload"
              drag
              :auto-upload="false"
              :http-request="uploadToCos"
              :before-upload="beforeUpload"
              :on-change="addFile"
              action=""
              :on-remove="handleRemove"
            >
              <i class="el-icon-upload"></i>
              <div class="el-upload__text">
                参照模板整理文件，可将文件拖拽到此区域，或
                <em>{{ fileUrl === '' ? '点击上传' : '点击重新上传' }}</em>
              </div>
              <div class="el-upload__tip" slot="tip">
                目前仅支持xlsx格式
                <el-button type="text" @click="getImportExcel">下载模板</el-button>
              </div>
            </el-upload>
          </div>
        </div>
        <div v-show="importStatus === 2">
          <div class="import-tips">{{ importTips }}</div>
          <el-progress
            :text-inside="true"
            :stroke-width="24"
            :percentage="uploadPercentage"
          ></el-progress>
        </div>
        <!--样式原因，这边status就是4，不是错误-->
        <div v-show="importStatus === 4">
          <div class="import-tips">
            <div
              style="display: flex; justify-content: center; font-size: 80px; margin-bottom: 20px"
            >
              <i class="el-icon-success" style="color: #76c84d" v-if="uploadRes.Status === 2"></i>
              <i class="el-icon-warning" style="color: #ffa600" v-if="uploadRes.Status === 3"></i>
            </div>
            <span v-if="uploadRes.Status === 2">导入成功</span>
            <span v-if="uploadRes.Status === 3">导入失败</span>
          </div>
          <div style="margin-top: 40px; text-align: center">
            <span v-if="uploadRes.Status === 2">已导入了 {{ uploadRes.Count }} 条数据</span>
            <span v-if="uploadRes.Status === 3">
              请点击
              <a :href="uploadRes.FileUrl">下载文件</a>
              ，查看错误数据
            </span>
          </div>
        </div>
      </div>
      <div style="text-align: right">
        <el-button @click="resetImportStatus" v-show="importStatus !== 4">取消</el-button>
        <el-button type="primary" @click="importNext" v-show="importStatus !== 2">
          {{ importNextTips }}
        </el-button>
      </div>
    </el-dialog>
    <el-table :data="publishList" class="table" v-loading="tableLoading">
      <el-table-column prop="RosterName" label="名称">
        <template slot-scope="scope">
          <el-popover
            placement="bottom-start"
            title="修改名称"
            width="230"
            trigger="click"
            popper-class="edit_box"
          >
            <div>
              <el-input
                v-model="editRoster.RosterName"
                show-word-limit
                maxlength="16"
                @keyup.native.enter="saveEdit()"
              ></el-input>
              <div style="text-align: right; margin-top: 5px">
                <el-button size="mini" @click="closePopover">取消</el-button>
                <el-button size="mini" type="primary" @click="saveEdit()">确定</el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="openEdit(scope.row)">
                {{ scope.row.RosterName || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="Remarks" label="备注">
        <template slot-scope="scope">
          <el-popover
            placement="bottom-start"
            title="修改备注"
            width="230"
            trigger="click"
            popper-class="edit_box"
          >
            <div>
              <el-input
                v-model="editRoster.Remarks"
                show-word-limit
                maxlength="32"
                @keyup.native.enter="saveEdit()"
              ></el-input>
              <div style="text-align: right; margin-top: 5px">
                <el-button size="mini" @click="closePopover">取消</el-button>
                <el-button size="mini" type="primary" @click="saveEdit()">确定</el-button>
              </div>
            </div>
            <div slot="reference">
              <div class="edit_able" @click="openEdit(scope.row)">
                {{ scope.row.Remarks || '-' }}
              </div>
            </div>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="Num" label="人数"></el-table-column>
      <el-table-column prop="Operator" label="创建人"></el-table-column>
      <el-table-column prop="MTime" label="更新时间">
        <template slot-scope="scope">
          {{ scope.row.MTime | handleTime }}
        </template>
      </el-table-column>
      <el-table-column label="类型">
        <template slot-scope="scope">
          {{ scope.row.Type | getTypeStr }}
        </template>
      </el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="text" @click="showDetail(scope.row)">详情</el-button>
          <el-button type="text" @click="removeSheet(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="text-align: right">
      <el-pagination
        style="background-color: #ffffff; width: 100%"
        layout="total, prev,sizes, pager, next, jumper"
        :total="pageTotal"
        :page-sizes="g_pageSizesConfig"
        :page-size="pageSize"
        :current-page="pageIndex"
        @current-change="changePageIndex"
        @size-change="changePageSize"
      />
    </div>
  </div>
</template>

<script>
import PublishImportHistory from './components/publishImportHistory';
import { CosMixin } from '@/mixins/cos';
import {
  AddRoster,
  DelRoster,
  GetRosterList,
  GetRosterTemplate,
  ImportRosterData,
  UpdateRoster,
} from '@/api/roster';
import { getUploadSignApi } from '@/api/common';
import config from '@/config';
const TypeMap = {
  0: '医生名单',
  1: '粉丝名单',
};
export default {
  name: 'RosterList',
  components: { PublishImportHistory },
  filters: {
    handleTime(time) {
      if (time) {
        const date = new Date(time * 1000 + 8 * 3600 * 1000);
        return date.toJSON().substr(0, 19).replace('T', ' ').replace(/-/g, '.');
      }
      return '-';
    },
    getTypeStr(type) {
      return TypeMap[type] || '';
    },
  },
  mixins: [CosMixin],
  data() {
    return {
      form: {
        // 筛选表单
        name: '',
        time: [],
      },
      newSheet: {
        // 新建表单
        name: '',
        remarks: '',
        type: '',
      },
      editRoster: {
        // 修改表单
        RosterId: '',
        RosterName: '',
        Remarks: '',
      },
      publishList: [
        {
          RosterId: '',
          RosterName: '',
          Remarks: '',
        },
      ], // 名单列表
      selectSheet: '', // 选择名单

      pageSize: 10,
      pageIndex: 1,
      pageTotal: 1,
      tableLoading: false,

      dialogNewSheet: false,
      dialogImport: false,

      checkTypeFail: false,
      importStatus: 0, // 前端导入阶段
      fileUrl: '',
      suffix: '',
      uploadPercentage: 0,
      importTips: '名单上传中...',
      uploadRes: {
        Status: 3, // 后端导入状态，1导入中 2导入成功 3导入失败
        StatusMsg: '',
        FileUrl: '',
        Count: 0, // 成功导入数据的数量
      },

      typeOptions: [
        {
          value: 0,
          label: '医生名单',
        },
        {
          value: 1,
          label: '粉丝名单',
        },
      ],
    };
  },
  computed: {
    importNextTips() {
      if (this.importStatus === 4) {
        return '关闭';
      }
      return '下一步';
    },
    importSheetType() {
      return this.publishList.find((i) => i.RosterId === this.selectSheet).Type;
    },
  },
  watch: {
    dialogNewSheet: {
      handler(val) {
        if (!val) {
          setTimeout(() => {
            // 300是dialog关闭动画的时间
            this.newSheet.name = '';
            this.newSheet.type = '';
            this.newSheet.remarks = '';
          }, 300);
        }
      },
    },
  },
  created() {
    this.getPublishList();
  },
  methods: {
    getPublishList() {
      this.tableLoading = true;
      GetRosterList({
        PageIndex: this.pageIndex,
        PageSize: this.pageSize,
        OrderBy: '',
        Type: -1,
        RosterName: this.form.name,
        STime: this.form.time ? new Date(this.form.time[0]).getTime() / 1000 : '',
        ETime: this.form.time ? new Date(this.form.time[1]).getTime() / 1000 + 86399 : '',
      })
        .then((res) => {
          this.pageTotal = res.Total;
          this.publishList = res.Rosters;
        })
        .catch((e) => {
          this.$message.error(e);
        })
        .finally(() => {
          this.tableLoading = false;
        });
    },
    changePageIndex(val) {
      this.pageIndex = val;
      this.getPublishList();
    },
    changePageSize(val) {
      this.pageSize = val;
      this.getPublishList();
    },
    showDetail(item) {
      console.log(item);
      this.g_tourl(
        `/saas/rosterList/rosterDetail.html?rosterId=${item.RosterId}&rosterType=${item.Type}`,
      );
    },
    removeSheet(item) {
      // console.log(item);
      this.$confirm('名单删除后，关联的人员和部门也将删除，确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        DelRoster({
          RosterId: item.RosterId,
        })
          .then(() => {
            this.$message.success('删除成功！');
            this.changePageIndex(1);
            setTimeout(() => {
              this.getPublishList();
            }, 300);
          })
          .catch((e) => {
            this.$message.error(e);
          });
      });
    },
    addSheet() {
      if (this.newSheet.name.length === 0 || this.newSheet.name.match('^[ ]+$')) {
        this.$message.warning('请输入名称');
        return;
      }
      if (this.newSheet.type === '') {
        this.$message.warning('请选择名单类型');
        return;
      }
      if (this.newSheet.remarks.match('^[ ]+$')) {
        this.$message.warning('备注不能为空格');
        return;
      }
      AddRoster({
        Name: this.newSheet.name,
        Remarks: this.newSheet.remarks,
        type: this.newSheet.type,
      })
        .then(() => {
          this.$message.success('新建成功！');
          this.changePageIndex(1);
          this.dialogNewSheet = false;
          setTimeout(() => {
            this.getPublishList();
          }, 300);
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    openEdit(item) {
      this.editRoster = { ...item };
    },
    closePopover() {
      document.body.click();
    },
    saveEdit() {
      if (this.editRoster.RosterName.length === 0 || this.editRoster.RosterName.match('^[ ]+$')) {
        this.$message.warning('名称不能为空');
        return;
      }
      if (this.editRoster.Remarks.match('^[ ]+$')) {
        this.$message.warning('备注不能为空格');
        return;
      }
      UpdateRoster({
        RosterId: this.editRoster.RosterId,
        Name: this.editRoster.RosterName,
        Remarks: this.editRoster.Remarks,
      })
        .then(() => {
          this.$message.success('更新成功！');
          this.closePopover();
          this.changePageIndex(1);
          this.getPublishList();
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    importNext() {
      switch (this.importStatus) {
        case 0:
          if (!this.selectSheet) {
            this.$message.warning('请选择要导入的名单');
            return;
          }
          break;
        case 1:
          if (this.$refs.upload.uploadFiles.length === 0) {
            this.$message.warning('请选择导入文件');
            return;
          }
          this.$refs.upload.submit();
          break;
        case 2:
          // 最后一步要跳两下
          this.importStatus += 1;
          break;
        case 4:
          this.resetImportStatus();
          break;
      }
      if (this.checkTypeFail) {
        return;
      }
      this.importStatus += 1;
    },
    resetImportStatus() {
      // 清空导入进度，300为dialog渐出的时间
      this.dialogImport = false;
      this.getPublishList();
      setTimeout(() => {
        this.selectSheet = '';
        this.$refs.upload.clearFiles();
        this.importStatus = 0;
      }, 300);
    },
    addFile(file, fileList) {
      // console.log(file);
      // console.log(fileList);
      if (fileList.length > 1) {
        fileList.splice(0, 1);
      }
    },
    beforeUpload(file) {
      // 上传前判断格式
      if (!/.xlsx$/gi.test(file.name)) {
        this.checkTypeFail = true;
        this.$message.warning('请选择格式正确的文件');
        return false;
      }
      this.checkTypeFail = false;
      this.suffix = `.${file.name.split('.')[1]}`;
      return true;
    },
    handleRemove() {
      this.flieUrl = '';
    },
    getImportExcel() {
      GetRosterTemplate({
        TemplateKey: this.importSheetType ? 'FansRoster' : 'PushRoster',
        type: this.importSheetType,
      })
        .then((res) => {
          this.g_tourl(res.TemplateUrl, { open: true });
        })
        .catch((e) => {
          this.$message.error(e);
        });
    },
    uploadToCos(file) {
      // 文件上传至腾讯云cos
      const pattern = new RegExp(
        "[%--`~!@#$^&*()=|{}':;',\\[\\]<>/?~！@#￥……&*（）——| {}【】‘；：”“'。，、？]",
      );
      const s = file.file.name;
      let rs = '';
      for (let i = 0; i < s.length; i++) {
        rs = rs + s.substr(i, 1).replace(pattern, '');
      }
      this.putCosObject(
        {
          imgCosKey: `${file.file.uid}${rs}`,
          fileObject: file.file,
        },
        undefined,
        (progressData) => {
          console.log(progressData);
          this.uploadPercentage = progressData.percent * 20;
        },
        async () => {
          const res = await getUploadSignApi({
            app_id: config.cosAppId,
            credentials: 1,
            suffix: this.suffix,
          });
          const { sessionToken, tmpSecretId, tmpSecretKey } = res?.data?.credentials || {};
          const {
            cdn_url: cdnUrl,
            key,
            startTime,
            expiredTime,
            Region: region,
            Bucket: bucket,
          } = res?.data || {};
          return {
            tmpSecretId,
            tmpSecretKey,
            sessionToken,
            cdnUrl,
            key,
            startTime,
            expiredTime,
            region,
            bucket,
          };
        },
      )
        .then((res) => {
          this.fileUrl = res.data;
          this.importTips = '名单导入中...';
          this.upLoadToBackEnd();
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    upLoadToBackEnd() {
      // 后端检查并导入数据
      const mission = setInterval(() => {
        ImportRosterData({
          FileUrl: this.fileUrl,
          RosterId: this.selectSheet,
          type: this.importSheetType,
        })
          .then((res) => {
            if (res.Status === 1) {
              // 仍需等待
              if (this.uploadPercentage < 80) {
                this.uploadPercentage += 10;
              } else if (this.uploadPercentage < 90) {
                this.uploadPercentage += 2;
              } else if (this.uploadPercentage < 99) {
                this.uploadPercentage += 1;
              }
            } else {
              // 导入结束
              clearInterval(mission);
              this.uploadPercentage = 100;
              this.uploadRes = res;
              setTimeout(() => {
                this.importNext();
              }, 300);
            }
          })
          .catch((e) => {
            clearInterval(mission);
            this.importTips = `发生错误：${e.message}`;
          });
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.form {
  ::v-deep.el-form-item {
    .el-form-item__label {
      font-size: 16px;
      color: #303133;
    }
  }
}
.table {
  font-size: 16px;
  thead {
    color: #313233;
  }
}
.import-container {
  height: 240px;
  margin: 20px 0;
}
.import-tips {
  padding-top: 20px;
  margin-bottom: 20px;
  text-align: center;
  font-size: 30px;
}
::v-deep.upload {
  text-align: center;
  .el-upload {
    .el-upload-dragger {
      width: 450px;
      height: 150px;
    }
  }
  .el-upload-list__item-name {
    padding: 0;
    margin: 0;
  }
}
// 表格鼠标文字编辑悬浮
.edit_able {
  position: relative;
  cursor: pointer;
  padding-right: 10px;
  &:hover {
    // text-decoration: underline;
    // color: #5fa4e8;
    &:after {
      position: absolute;
      //   content: '🖋🖊🖌🖍';
      content: '🖊';
      display: inline-block;
      font-size: 20px;
      padding-left: 5px;
      text-decoration: underline;
    }
  }
}
</style>
